import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  stepRoot: {
    width: '100%',
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      flex: '1 0 auto',
      minHeight: '100%',
    },
  },
  stepFormColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flex: '1 0 auto',
      minHeight: '100%',
    },
  },
  stepMain: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    flexShrink: 0,
  },
  /** Guest auth: grow so {@link authPromptRegion} can center in the remaining height. */
  stepMainGuest: {
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: 0,
    },
  },
  stepActionsFooter: {
    flexShrink: 0,
    width: '100%',
    [theme.breakpoints.down('md')]: {
      marginTop: 'auto',
    },
  },
  formGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  /** Guest auth prompt: grow to fill {@link stepMain} so log-in/up can center vertically. */
  formGridGuest: {
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: 0,
    },
  },
  passwordFieldAdornment: {
    paddingRight: theme.spacing(1),
  },
  checkmark: {
    color: theme.palette.custom.green.main,
  },
  /** Matches {@link CheckoutSubmitButtons} layout: row on desktop, stacked on mobile. */
  actionButtonsRoot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  actionButtonsWrap: {
    width: 'auto',
    flexShrink: 0,
  },
  paypalSubmitButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 400,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
    '& > div': {
      height: '40px',
      width: '100%',
    },
  },
  authPromptRegion: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: 0,
    },
  },
  authPrompt: {
    width: '100%',
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  authPromptButtons: {
    justifyContent: 'center',
    width: '100%',
  },
  authPromptButton: {
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      flex: 1,
    },
  },
  /** Sits directly above action buttons; keeps widget aligned on narrow viewports. */
  captchaSection: {
    flexShrink: 0,
    width: '100%',
    '& > div': {
      maxWidth: '100%',
    },
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
}));
